/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MAM_STATUS, MODULE, BOOLEAN_STATUS, SUBTITLING_CODE, TOAST_TYPES, ROLETYPE } from '../../framework/constant/constant';
import { useTranslation } from '../../locale/useTranslation';
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { EditPageHeader } from '../../components/EditPageHeader';
import { utility } from '../../framework/utility/utilityProvider';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { LocalDateTimeColumn } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import MAMStatusCell from '../../components/MAMStatusCell';
import ToastNotification from '../../components/ToastNotification';

const MediaMamAssetsEditForm = (props) => {

  const navigate = useNavigate();
  const lang = useTranslation();
  const user = utility.getValue(LOCALSTORAGE_KEY.userData);
  const isAdmin = user?.RoleType?.ID == ROLETYPE.Admin || user?.RoleType?.ID == ROLETYPE.SuperAdmin;

  let blankDataItem = {
    SID: props.item.SID ?? 0,
    CSID: '',
    Title: '',
    AssetId: "",
    StartTime: "00:00:00:00",
    EndTime: "00:00:00:00",
    ActualDuration: "00:00:00:00",
    TXReady: false,
    SubtitleAvailble: false,
    CensorshipReportAvailable: false,
    QcPass: false,
    Status: {},
    Archive: false,
    MediaEpisode_id: '',
  }

  const [dataItem, setDataItem] = useState(blankDataItem);
  const [ingestPrototype, setIngestPrototype] = useState([]);
  const [transcodePrototype, setTranscodePrototype] = useState([]);
  const [tabNumber, setTabNumber] = React.useState("1");
  const [historyData, setHistoryData] = useState([]);
  const [transcodeDefinitions, setTranscodeDefinitions] = useState([]);

  let mediaEpisodeRef = useRef();

  useEffect(() => {
    loadcombo();
    if (props?.item?._id) loadEditData();
  }, []);


  const loadcombo = async () => {
    let ingestprototypeRes = await API.getDataLookup(ENTITYNAME.INGEST_PROTOTYPE, { sort: { Description: 1 } });
    setIngestPrototype(ingestprototypeRes.data);
    let transcodeprototypeRes = await API.getDataLookup(ENTITYNAME.TranscodePrototypes, { sort: { Description: 1 } });
    setTranscodePrototype(transcodeprototypeRes.data);
    const transcodeDefinitionRes = await API.getDataLookup(ENTITYNAME.TranscodeDefinition, { sort: { Description: 1 } });
    setTranscodeDefinitions(transcodeDefinitionRes.data);

    let mediaEpisodeRes = await API.getDataLookup(ENTITYNAME.MediaEpisode, { query: ["_id", "=", props.item.MediaEpisode_id ?? props?.item?.MediaEpisode?._id] });
    mediaEpisodeRef.current = mediaEpisodeRes.data.length > 0 ? mediaEpisodeRes.data[0] : {};
  }

  const loadEditData = async () => {
    const { History, ...item } = props.item;
    setDataItem(prev => ({
      ...prev,
      ...item,
      SID: item.copy ? 0 : parseInt(item.SID),
      Title: item.copy ? `Copy of ${item.Title}` : item.Title,
      StartTime: item?.StartTime ? utility.convertMilisecondsToStringWithFrames(item?.StartTime) : "00:00:00:00",
      EndTime: item?.EndTime ? utility.convertMilisecondsToStringWithFrames(item?.EndTime) : "00:00:00:00",
      ActualDuration: item?.ActualDuration ? utility.convertMilisecondsToStringWithFrames(item?.ActualDuration) : "00:00:00:00",
      BitRate: item?.TechnicalDetails?.BitRate,
      FileSize: item?.TechnicalDetails?.FileSize,
      FileLocation: item?.TechnicalDetails?.FileLocation,
      Checksum: item?.TechnicalDetails?.Checksum,
      format: item?.TechnicalDetails?.format,
      frameDuration: item?.TechnicalDetails?.frameDuration,
      Definition: item?.TechnicalDetails?.Definition ?? {},
      StatusText: item?.TechnicalDetails?.StatusText,
      Status: { _id: item?.Status, Description: utility.getKeyByValue(MAM_STATUS, item?.Status) },
    }));
    if (History?.length > 0) {
      const shortHistoryData = History.sort((a, b) => a.Timestamp - b.Timestamp);
      setHistoryData(shortHistoryData);
    } else {
      setHistoryData([]);
    }
  };


  const onChange = async (e) => {
    if (e.target.name == "Archive") {
      setDataItem({ ...dataItem, Archive: !dataItem.Archive });
      console.log(!dataItem.Archive)
    }
    else if (e.target.name == "TXReady") {
      setDataItem({ ...dataItem, TXReady: !dataItem.TXReady });
      console.log(!dataItem.TXReady)
    }
    else if (e.target.name == "SubtitleAvailble") {
      setDataItem({ ...dataItem, SubtitleAvailble: !dataItem.SubtitleAvailble });
      console.log(!dataItem.SubtitleAvailble)
    }
    else if (e.target.name == "CensorshipReportAvailable") {
      setDataItem({ ...dataItem, CensorshipReportAvailable: !dataItem.CensorshipReportAvailable });
      console.log(!dataItem.CensorshipReportAvailable)
    }
    else if (e.target.name == "QcPass") {
      setDataItem({ ...dataItem, QcPass: !dataItem.QcPass });
      console.log(!dataItem.QcPass)
    }
    else {
      setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }
  };

  const isValid = () => {

    if (dataItem.Title == undefined || dataItem.Title == '') {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
      return false;
    }
    if (dataItem.AssetId == undefined || dataItem.AssetId == '') {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_assetid_error_message });
      return false;
    }
    if (dataItem.StartTime == undefined || dataItem.StartTime == '') {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_start_time_message });
      return false;
    }

    if (dataItem.EndTime == undefined || dataItem.EndTime == '') {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_end_time_message });
      return false;
    }

    if (dataItem.ActualDuration == undefined || dataItem.ActualDuration == '' || utility.convertStringWithFramesToMilliseconds(dataItem.ActualDuration) == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_valid_actual_duration_message });
      return false;
    }
    if (!dataItem.Status || !dataItem.Status._id) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_status_error_message });
      return false;
    }
    // if (!dataItem.IngestPrototype || Object.keys(dataItem.IngestPrototype).length == 0) {
    //   ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_ingest_prototype_error_message });
    //   return false
    // }
    // if (!dataItem.TranscodePrototype || Object.keys(dataItem.TranscodePrototype).length == 0) {
    //   ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_transcode_prototype_error_message });
    //   return false
    // }

    return true;
  }

  const onSaveData = async () => {

    if (!isValid()) return;

    const data = {
      _id: dataItem?._id,
      SID: dataItem?.SID,
      CSID: dataItem?.CSID,
      Title: dataItem?.Title,
      AssetId: dataItem?.AssetId,
      StartTime: utility.convertStringWithFramesToMilliseconds(dataItem?.StartTime),
      EndTime: utility.convertStringWithFramesToMilliseconds(dataItem?.EndTime),
      ActualDuration: utility.convertStringWithFramesToMilliseconds(dataItem?.ActualDuration),
      TXReady: dataItem?.TXReady ? true : false,
      SubtitleAvailble: dataItem?.SubtitleAvailble ? true : false,
      CensorshipReportAvailable: dataItem?.CensorshipReportAvailable ? true : false,
      QcPass: dataItem?.QcPass ? true : false,
      TechnicalDetails: {
        ...(dataItem?.TechnicalDetails || {}),
        BitRate: dataItem?.BitRate,
        FileSize: dataItem?.FileSize,
        FileLocation: dataItem?.FileLocation,
        Checksum: dataItem?.Checksum,
        format: dataItem?.format,
        frameDuration: dataItem?.frameDuration,
        Definition: dataItem?.Definition && Object.keys(dataItem?.Definition).length > 0 ? {
          _id: dataItem?.Definition?._id,
          Description: dataItem?.Definition?.Description
        } : {},
        StatusText: dataItem?.StatusText
      },
      Status: dataItem.Status._id,
      IngestPrototype: dataItem.IngestPrototype || {},
      TranscodePrototype: dataItem.TranscodePrototype || {},
      Archive: dataItem?.Archive ? true : false,
      History: [...historyData, {
        Status: dataItem.Status._id,
        Timestamp: Date.now(),
        AddBy: { _id: user._id, name: user.name }
      }]
    };

    props.item.copy && delete data._id

    const res = await API.saveData(ENTITYNAME.MediaMamAssets, data);
    if (res.success) {
      let logData = { event: data.SID == 0 ? LOGEVENT.CREATE_MAM_ASSETS : LOGEVENT.UPDATE_MAM_ASSETS, module: MODULE.MEDIA_EPISODE_MAMASSETS, data: res.data, message: res.message };
      API.SaveLogs(logData);
      props.cancelEdit();
      props.refresh();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  const openMedia = (dataItem) => {
    if (mediaEpisodeRef.current.SID > 0) {
      props.cancelEdit();
      window.open(`/home/MediaEpisode/${mediaEpisodeRef.current?.MediaCategory?.Description}/${mediaEpisodeRef.current?.SID}`, { state: { copy: false } })
      //navigate(`/home/MediaEpisode/${mediaEpisodeRef.current?.MediaCategory?.Description}/${mediaEpisodeRef.current?.SID}`, { state: { copy: false } })
    } else {
      console.log('Select Media');
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.select_media_info_message });
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  // Helper to display boolean/code fields that may be raw numbers or objects
  const getBoolLabel = (val) => {
    if (val === null || val === undefined) return "";
    const raw = (typeof val === 'object' && val._id !== undefined) ? val._id : val;
    return utility.getKeyByValue(BOOLEAN_STATUS, raw) || "";
  };
  const getCodeLabel = (val) => {
    if (val === null || val === undefined) return "";
    const raw = (typeof val === 'object' && val._id !== undefined) ? val._id : val;
    return utility.getKeyByValue(SUBTITLING_CODE, raw) || "";
  };

  return (
    <BossDialog
      title={props?.item?._id ? dataItem.Title : `${lang.create_mamasset_dialog_header}`}
      onClose={props.cancelEdit}
      width={"60vw"}
    >
      <div className="row">
        <div className="col" >
          <EditPageHeader onSubmit={onSaveData} onCancel={props.cancelEdit} showTitle={false} OpenMediaButton={true} onShowMedia={openMedia} />
        </div>
        {props?.item?.CSID && (
          <div className="col-auto d-flex align-items-center pull-right">
            <label className="mb-0 mr-2">{lang.mamID_label} :</label>
            <input
              name="CSID"
              type="text"
              className="form-control form-control-sm"
              value={dataItem.CSID}
              disabled
              style={{ width: "160px" }}
            />
          </div>
        )}
      </div>
      <div className="row mt-2" >
        <div className='col-6'>
          <div className="form-group">
            <label htmlFor="">{lang.title_label} *</label>
            <input name="Title" type="text" className="form-control form-control-sm" value={dataItem.Title} onChange={(e) => onChange(e)} disabled={!isAdmin} />
          </div>
        </div>
        <div className='col-6'>
          <div className="form-group">
            <label htmlFor="">{lang.asset_id_label} *</label>
            <input name="AssetId" type="text" className="form-control form-control-sm" value={dataItem.AssetId} onChange={(e) => onChange(e)} disabled={!isAdmin} />
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-3">
          <div className="form-group">
            <label htmlFor="">{lang.start_time_label} *</label>
            <TimePickerWithFormat
              className="form-control form-control-sm mt-1"
              name="StartTime"
              value={dataItem.StartTime}
              onChange={onChange}
              disabled={!isAdmin}
            />
          </div>
        </div>
        <div className="col-3">
          <div className="form-group">
            <label htmlFor="">{lang.end_time_label} *</label>
            <TimePickerWithFormat
              className="form-control form-control-sm mt-1"
              name="EndTime"
              value={dataItem.EndTime}
              onChange={onChange}
              disabled={!isAdmin}
            />
          </div>
        </div>
        <div className='col-3'>
          <div className="form-group">
            <label htmlFor="">{lang.actual_duration_label} *</label>
            <TimePickerWithFormat
              className="form-control form-control-sm mt-1"
              name="ActualDuration"
              value={dataItem.ActualDuration}
              onChange={onChange}
              disabled={!isAdmin}
            />
          </div>
        </div>
        <div className='col-3'>
          <div className="form-group">
            <label htmlFor="">{lang.status_label} *</label>
            <DropDownList
              data={
                Object.keys(MAM_STATUS).map((obj) => {
                  return {
                    _id: MAM_STATUS[obj],
                    Description: obj
                  }
                })
              }
              name="Status"
              textField="Description"
              dataItemKey="_id"
              value={dataItem.Status}
              onChange={onChange}
              disabled={!isAdmin}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3 form-group">
        <div className="col">
          <input type="checkbox" name={"TXReady"} value={dataItem.TXReady} checked={dataItem.TXReady} onChange={onChange} disabled={!isAdmin} /> {lang.tx_ready_label}
        </div>
        <div className="col">
          <input type="checkbox" name={"SubtitleAvailble"} value={dataItem.SubtitleAvailble} checked={dataItem.SubtitleAvailble} onChange={onChange} disabled={!isAdmin} /> {lang.subtitle_availble_label}
        </div>
        <div className="col-3">
          <input type="checkbox" name={"CensorshipReportAvailable"} value={dataItem.CensorshipReportAvailable} checked={dataItem.CensorshipReportAvailable} onChange={onChange} disabled={!isAdmin} /> {lang.censorship_report_available_label}
        </div>
        <div className="col">
          <input type="checkbox" name={"QcPass"} value={dataItem.QcPass} checked={dataItem.QcPass} onChange={onChange} disabled={!isAdmin} /> {lang.qcpass_label}
        </div>
        <div className="col">
          <input type="checkbox" name={"Archive"} checked={dataItem.Archive} onChange={onChange} disabled={!isAdmin} /> {lang.archive}
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Box sx={{ width: "100%" }}>
            <TabContext value={tabNumber}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                  <Tab label="Technical Details" value="1" />
                  <Tab label="History" value="2" />
                  {dataItem.IngestPrototype && Object.keys(dataItem.IngestPrototype).length > 0 && (
                    <Tab label="Ingest Prototype" value="3" />
                  )}
                  {dataItem.TranscodePrototype && Object.keys(dataItem.TranscodePrototype).length > 0 && (
                    <Tab label="Transcode Prototype" value="4" />
                  )}
                </TabList>
              </Box>
              <TabPanel value="1">
                <div className="border p-2 form-group with-3d-effect" style={{ border: "1px solid #ced4da", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", backgroundColor: "#FAFAFA" }}>
                  <div className="row form-group">
                    <div className="col-3">
                      <label>{lang.bit_rate_label}</label>
                      <input name="BitRate" type="text" className="form-control form-control-sm" value={dataItem.BitRate} onChange={onChange} disabled={!isAdmin} />
                    </div>
                    <div className="col-3">
                      <label>{lang.file_size_label}</label>
                      <input name="FileSize" type="text" className="form-control form-control-sm" value={dataItem.FileSize} onChange={onChange} disabled={!isAdmin} />
                    </div>
                    <div className="col-3">
                      <label>{lang.file_location_label}</label>
                      <input name="FileLocation" type="text" className="form-control form-control-sm" value={dataItem.FileLocation} onChange={onChange} disabled={!isAdmin} />
                    </div>
                    <div className="col-3">
                      <label>{lang.checksum_label}</label>
                      <input name="Checksum" type="text" className="form-control form-control-sm" value={dataItem.Checksum} onChange={onChange} disabled={!isAdmin} />
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col-3">
                      <label>{lang.format_label}</label>
                      <input name="format" type="text" className="form-control form-control-sm" value={dataItem.format} onChange={onChange} disabled={!isAdmin} />
                    </div>
                    <div className="col-3">
                      <label>{lang.frame_duration_label}</label>
                      <input name="frameDuration" type="text" className="form-control form-control-sm" value={dataItem.frameDuration} onChange={onChange} disabled={!isAdmin} />
                    </div>
                    <div className="col-3">
                      <label htmlFor="">{lang.definition_label}</label>
                      <DropDownList
                        data={transcodeDefinitions}
                        name="Definition"
                        textField="Description"
                        dataItemKey="_id"
                        value={dataItem.Definition}
                        onChange={onChange}
                        disabled={!isAdmin}
                      />
                    </div>
                    <div className="col-3">
                      <label>{lang.status_text_label}</label>
                      <input name="StatusText" type="text" className="form-control form-control-sm" value={dataItem.StatusText} onChange={onChange} disabled={!isAdmin} />
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel value="2">
                <Grid data={historyData} style={{ height: "230px" }}>
                  <GridColumn field="Status" title="Status" cell={MAMStatusCell} />
                  <GridColumn field="Timestamp" title="Date" cell={LocalDateTimeColumn} />
                  <GridColumn field="FileName" title="File Name" />
                  <GridColumn field="AddBy.name" title="Added By" />
                </Grid>
              </TabPanel>
              {dataItem.IngestPrototype && Object.keys(dataItem.IngestPrototype).length > 0 && (
                <TabPanel value="3">
                  <div className="border p-2 form-group" style={{ border: "1px solid #ced4da", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", backgroundColor: "#FAFAFA" }}>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.description_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.IngestPrototype?.Description || ""} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.transmission_type_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.IngestPrototype?.TransmissionType?.Name || ""} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.asset_group_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.IngestPrototype?.AssetGroup || ""} disabled />
                      </div>
                    </div>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.direct_ingest_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.IngestPrototype?.DirectIngest)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.censorship_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.IngestPrototype?.CensorshipFlag)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.dual_sound_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.IngestPrototype?.DualSound)} disabled />
                      </div>
                    </div>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.thumbnail_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.IngestPrototype?.Thumbnail)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.hd_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.IngestPrototype?.HD)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.language1_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.IngestPrototype?.Language1 || ""} disabled />
                      </div>
                    </div>
                    <div className="row form-group">
                      <div className="col-3">
                        <label>{lang.subtitles_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.IngestPrototype?.SubtitlesFlag)} disabled />
                      </div>
                      <div className="col-3">
                        <label>{lang.subtitling_code_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getCodeLabel(dataItem.IngestPrototype?.SubtitlingCode)} disabled />
                      </div>
                      <div className="col-3">
                        <label>{lang.subtitling_lang_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.IngestPrototype?.SubtitlingLang || ""} disabled />
                      </div>
                      <div className="col-3">
                        <label>{lang.subtitling_mode_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.IngestPrototype?.SubtitlingMode || ""} disabled />
                      </div>
                    </div>
                  </div>
                </TabPanel>
              )}
              {dataItem.TranscodePrototype && Object.keys(dataItem.TranscodePrototype).length > 0 && (
                <TabPanel value="4">
                  <div className="border p-2 form-group" style={{ border: "1px solid #ced4da", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", backgroundColor: "#FAFAFA" }}>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.description_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.TranscodePrototype?.Description || ""} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.transmission_type_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.TranscodePrototype?.TransmissionType?.Name || ""} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.audio_mode_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.TranscodePrototype?.AudioMode || ""} disabled />
                      </div>
                    </div>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.title_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.TranscodePrototype?.TitleFlag)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.logo_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.TranscodePrototype?.LogoFlag)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.logo_opposite_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.TranscodePrototype?.LogoOpposite)} disabled />
                      </div>
                    </div>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.ending_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.TranscodePrototype?.EndingFlag)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.reverse_audio_channel_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.TranscodePrototype?.ReverseAudioChannelFlag)} disabled />
                      </div>
                      <div className="col-4">
                        <label>{lang.tag_flag_label}</label>
                        <input type="text" className="form-control form-control-sm" value={getBoolLabel(dataItem.TranscodePrototype?.TagFlag)} disabled />
                      </div>
                    </div>
                    <div className="row form-group">
                      <div className="col-4">
                        <label>{lang.definition_label}</label>
                        <input type="text" className="form-control form-control-sm" value={dataItem.TranscodePrototype?.Definition?.Description || ""} disabled />
                      </div>
                    </div>
                  </div>
                </TabPanel>
              )}
            </TabContext>
          </Box>
        </div>
      </div>
    </BossDialog >
  )
}

export default MediaMamAssetsEditForm